define([
  'jquery',
  'jquery-ui/ui/i18n/datepicker-nl'
], ($) => {
  // override datepicker "_adjustDate" so we can trigger a custom event

  // eslint-disable-next-line prefer-destructuring
  const _adjustDate = $.datepicker._adjustDate;
  $.datepicker._adjustDate = function _adjustDateReplacement(id, offset, period) {
    // eslint-disable-next-line prefer-rest-params
    _adjustDate.apply($.datepicker, arguments);
    if (period === 'M') {
      $(id).trigger('_adjustDateByMonth');
    }
  };
});
